import { authorizedFetch } from '@/lib/api'

async function parseApiErrorMessage(response: Response, fallback: string): Promise<string> {
  const text = await response.text().catch(() => '')
  const trimmed = text.trim()
  if (!trimmed) {
    return `${fallback} (${response.status})`
  }
  try {
    const data = JSON.parse(trimmed) as Record<string, unknown>
    if (typeof data.detail === 'string' && data.detail) return data.detail
    if (typeof data.error === 'string' && data.error) return data.error
  } catch {
    /* not JSON */
  }
  return trimmed.length > 300 ? `${trimmed.slice(0, 297)}…` : trimmed
}

function filenameFromDisposition(header: string | null): string {
  if (!header) return 'profile.pdf'
  const quoted = /filename="([^"]+)"/.exec(header)
  if (quoted?.[1]) return quoted[1]
  return 'profile.pdf'
}

export async function downloadProfilePdf(profileId: string): Promise<void> {
  const response = await authorizedFetch(`/api/profiles/${encodeURIComponent(profileId)}/pdf/`)
  if (!response.ok) {
    throw new Error(await parseApiErrorMessage(response, 'Failed to download PDF'))
  }
  const blob = await response.blob()
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filenameFromDisposition(response.headers.get('Content-Disposition'))
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
